var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientReservation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Client Reservation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,9 C10.0025,9 14,10.1166667 14,12.3333333 L14,12.3333333 L14,14 L2,14 L2,12.3333333 C2,10.1166667 5.9975,9 8,9 Z M8,10 C6.9748501,10 5.36023376,10.3294128 4.17779371,10.9863239 C3.79172465,11.2008067 3.45109307,11.4475997 3.22370524,11.7460756 C3.09096279,11.9203173 3,12.1132261 3,12.3333333 L3,12.3333333 L3,13 L13,13 L13,12.3333333 L12.9894779,12.2044646 C12.9619437,12.0368093 12.8824887,11.8854689 12.7762948,11.7460756 C12.5489069,11.4475997 12.2082753,11.2008067 11.8222063,10.9863239 C10.6397662,10.3294128 9.0251499,10 8,10 Z M8,2 C9.6575,2 11,3.3425 11,5 C11,6.6575 9.6575,8 8,8 C6.3425,8 5,6.6575 5,5 C5,3.3425 6.3425,2 8,2 Z M8,3 C7.4475,3 6.94743993,3.22364863 6.58554428,3.58554428 C6.22364863,3.94743993 6,4.4475 6,5 C6,5.5525 6.22364863,6.05256007 6.58554428,6.41445572 C6.94743993,6.77635137 7.4475,7 8,7 C8.5525,7 9.05256007,6.77635137 9.41445572,6.41445572 C9.77635137,6.05256007 10,5.5525 10,5 C10,4.4475 9.77635137,3.94743993 9.41445572,3.58554428 C9.05256007,3.22364863 8.5525,3 8,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Level/Active/Reservation-Client",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#34436D",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientReservation);
export default __webpack_public_path__ + "static/media/ClientReservation.6a063732.svg";
export { ForwardRef as ReactComponent };